/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zany_Teary_Mayfly_PlayInputs */

const en_zany_teary_mayfly_play = /** @type {(inputs: Zany_Teary_Mayfly_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiments`)
};

const de_zany_teary_mayfly_play = /** @type {(inputs: Zany_Teary_Mayfly_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente`)
};

/**
* | output |
* | --- |
* | "Experiments" |
*
* @param {Zany_Teary_Mayfly_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const zany_teary_mayfly_play = /** @type {((inputs?: Zany_Teary_Mayfly_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zany_Teary_Mayfly_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zany_teary_mayfly_play(inputs)
	return de_zany_teary_mayfly_play(inputs)
});